/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDatabaseCrossBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon base">
      <g id="custom/database-offline">
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.62203 4.21311C2.4641 4.55181 2.375 4.91871 2.375 5.3125V8.4375V11.5625V14.6875C2.375 16.0739 3.47937 17.1271 4.80323 17.789C6.17195 18.4734 8.01033 18.875 10 18.875C11.9897 18.875 13.828 18.4734 15.1968 17.789C15.417 17.6789 15.6312 17.5579 15.8353 17.4264L14.7425 16.3336C14.6733 16.3718 14.6011 16.4098 14.5259 16.4474C13.4064 17.0071 11.8073 17.375 10 17.375C8.19271 17.375 6.59359 17.0071 5.47405 16.4474C4.30965 15.8652 3.875 15.1996 3.875 14.6875V14.1022C4.16208 14.3128 4.47595 14.5004 4.80323 14.664C6.17195 15.3484 8.01033 15.75 10 15.75C11.3188 15.75 12.5711 15.5736 13.6642 15.2553L12.4249 14.0159C11.6843 14.1655 10.866 14.25 10 14.25C8.19271 14.25 6.59359 13.8821 5.47405 13.3224C4.30965 12.7402 3.875 12.0746 3.875 11.5625V10.9772C4.16208 11.1878 4.47595 11.3754 4.80323 11.539C6.17195 12.2234 8.01033 12.625 10 12.625C10.3381 12.625 10.6719 12.6134 10.9997 12.5908L9.5254 11.1165C7.91351 11.0584 6.49455 10.7076 5.47405 10.1974C4.30965 9.61516 3.875 8.94962 3.875 8.4375V7.85222C4.16208 8.06281 4.47595 8.25036 4.80323 8.414C5.62998 8.82737 6.62808 9.1376 7.72737 9.31846L5.48845 7.07954C5.48364 7.07715 5.47884 7.07475 5.47405 7.07236C4.43381 6.55224 3.97599 5.9656 3.89018 5.48127L2.62203 4.21311ZM11.2943 7.9356C12.5664 7.80702 13.6823 7.49417 14.5259 7.07236C15.6904 6.49016 16.125 5.82462 16.125 5.3125C16.125 4.80038 15.6904 4.13484 14.5259 3.55264C13.4064 2.99287 11.8073 2.625 10 2.625C8.68833 2.625 7.48631 2.81877 6.4977 3.13904L5.32984 1.97118C6.62718 1.43378 8.25544 1.125 10 1.125C11.9897 1.125 13.828 1.52664 15.1968 2.211C16.5206 2.87293 17.625 3.92614 17.625 5.3125V8.4375V11.5625V14.2663L15.7679 12.4092C16.018 12.1085 16.125 11.8166 16.125 11.5625V10.9772C15.8379 11.1878 15.524 11.3754 15.1968 11.539C15.1306 11.5721 15.0633 11.6045 14.9949 11.6363L13.8489 10.4903C14.0902 10.4001 14.3165 10.3021 14.5259 10.1974C15.6904 9.61516 16.125 8.94962 16.125 8.4375V7.85222C15.8379 8.06281 15.524 8.25036 15.1968 8.414C14.4569 8.78392 13.5799 9.07124 12.6158 9.25717L11.2943 7.9356Z"
          fill="currentColor"
        />
        <path
          id="Line 2"
          d="M2.10864 1.22485L17.942 17.0582"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
);
const SvgDatabaseCross = wrapIcon(SvgDatabaseCrossBase);
export default SvgDatabaseCross;
